import React from "react";
import Plot from "react-plotly.js";
import { connect } from "react-redux";

import ChartActions from "store/actions/charts";

import { CHART_PLOTLY_STRINGS } from "constants/constantStrings";
import { LOCAL_TIME_ZONE } from "constants/globalConstants";

import AddBaseLineModal from "components/AddBaseLineModal";

import ChartConstant from "../../constants/chartConstant.js";

class PlotlyChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      originalOverlay: {}, //alarms list
      originalMultiplotChart: {}, //alarms enabled status
      isBaselineFormOpen: false,
      chartBaselineTimestamp: "",
      baselines: null,
      baselineTimezone: LOCAL_TIME_ZONE
    };
  }

  getDownloadButton() {
    const icon = {
      width: 500,
      height: 500,
      path: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456zM233.4 374.6C239.6 380.9 247.8 384 256 384s16.38-3.125 22.62-9.375l128-128c12.49-12.5 12.49-32.75 0-45.25c-12.5-12.5-32.76-12.5-45.25 0L288 274.8V32c0-17.67-14.33-32-32-32C238.3 0 224 14.33 224 32v242.8L150.6 201.4c-12.49-12.5-32.75-12.5-45.25 0c-12.49 12.5-12.49 32.75 0 45.25L233.4 374.6z"
    };
    return {
      name: CHART_PLOTLY_STRINGS.downloadCSV,
      icon,
      click: () => this.props.plotEvents.onDownloadPlot()
    };
  }

  getRefreshBUtton() {
    const icon = {
      width: 500,
      height: 500,
      path: "M449.9 39.96l-48.5 48.53C362.5 53.19 311.4 32 256 32C161.5 32 78.59 92.34 49.58 182.2c-5.438 16.81 3.797 34.88 20.61 40.28c16.97 5.5 34.86-3.812 40.3-20.59C130.9 138.5 189.4 96 256 96c37.96 0 73 14.18 100.2 37.8L311.1 178C295.1 194.8 306.8 223.4 330.4 224h146.9C487.7 223.7 496 215.3 496 204.9V59.04C496 34.99 466.9 22.95 449.9 39.96zM441.8 289.6c-16.94-5.438-34.88 3.812-40.3 20.59C381.1 373.5 322.6 416 256 416c-37.96 0-73-14.18-100.2-37.8L200 334C216.9 317.2 205.2 288.6 181.6 288H34.66C24.32 288.3 16 296.7 16 307.1v145.9c0 24.04 29.07 36.08 46.07 19.07l48.5-48.53C149.5 458.8 200.6 480 255.1 480c94.45 0 177.4-60.34 206.4-150.2C467.9 313 458.6 294.1 441.8 289.6z"
    };

    return {
      name: CHART_PLOTLY_STRINGS.refreshData,
      icon,
      click: () => this.props.plotEvents.onPlotRefresh()
    };
  }

  getChartConfig() {
    const toImage = "toImage";
    const zoom2d = "zoom2d";
    const resetScale2d = "resetScale2d";
    const downloadButton = this.getDownloadButton();
    const refreshButton = this.getRefreshBUtton();
    const chartButtons = { displayModeBar: true, displaylogo: false, showTips: false };
    let modeBarButtons = [];
    if (this.props.isLiveChart) {
      modeBarButtons = [downloadButton, toImage];
    } else {
      modeBarButtons = [refreshButton, downloadButton, toImage, zoom2d, resetScale2d];
    }
    chartButtons.modeBarButtons = [modeBarButtons];
    return chartButtons;
  }

  handleLegendClick() {
    return false;
  }

  handleDoubleClick() {
    return false;
  }

  onClick(data) {
    if (this.props.createBaseline) {
      this.setState({
        isBaselineFormOpen: true,
        chartBaselineTimestamp: data?.points ? data?.points[0].x : "",
        baselines: this.props.baselinesList
      });
    } else {
      return false;
    }
  }
  onHover(e, createBaselineEnabled) {
    e.event.target.style.cursor = createBaselineEnabled ? "pointer" : "";
    this.props.onTagHover(e?.points[0].fullData.meta);
  }
  handleUnhover(e) {
    e.event.target.style.cursor = "";
  }
  setIsBaselineFormOpen() {
    this.setState({ isBaselineFormOpen: !this.state.isBaselineFormOpen, chartBaselineTimestamp: "" });
    this.props.setCreateBaseline(false);
    this.props.setEditCurrentView(ChartConstant.CHART_HEADER_ACTIONS.NONE);
  }

  setBaselines(updatedBaselines) {
    this.setState({ baselines: updatedBaselines });
  }
  render() {
    return (
      <>
        <Plot
          divId="ChartPlotRef"
          data={this.props.plotData}
          layout={this.props.plotLayout}
          config={this.getChartConfig()}
          useResizeHandler
          scrollZoom
          style={{ width: "100%", height: "100%" }}
          onRelayout={this.props?.plotEvents?.onPlotZoom}
          onLegendClick={this.handleLegendClick}
          onClick={data => this.onClick(data, this.customContextMenuRef)}
          onHover={e => this.onHover(e, this.props.createBaseline)}
          onUnhover={this.handleUnhover}
          onDoubleClick={this.handleDoubleClick}
        />
        {this.state.isBaselineFormOpen && (
          <AddBaseLineModal
            setIsBaselineFormOpen={() => this.setIsBaselineFormOpen()}
            chartBaselineTimestamp={this.state.chartBaselineTimestamp}
            baselines={this.state.baselines}
            setBaselines={() => this.setBaselines()}
            baselineTimezone={this.state.baselineTimezone}
            isClone
          />
        )}
      </>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  setEditCurrentView: action => dispatch(ChartActions.setEditCurrentView(action))
});
export default connect(null, mapDispatchToProps)(PlotlyChart);
